import requestStatuses from '@clearscore/constants.request-statuses';

import normaliseId from '../helpers/normalise-id';
import {
    TRANSACTIONS_AUTH,
    TRANSACTIONS_AUTH_ERROR,
    TRANSACTIONS_FETCH,
    TRANSACTIONS_FETCH_SUCCESS,
    TRANSACTIONS_FETCH_ERROR,
} from '../transactions.types';

const initialState = {
    status: requestStatuses.INITIAL,
    byId: {},
    allIds: [],
};

const normalizeAccountTransactionsData = (transactions) => {
    const byId = transactions.reduce((acc, { ...transaction }) => {
        const id = normaliseId(transaction);
        acc[id] = {
            id,
            accounts: [transaction.accountId],
        };
        return acc;
    }, {});

    return {
        byId,
        allIds: Object.keys(byId),
    };
};

export default function reportAccountTransactionsReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case TRANSACTIONS_AUTH:
            return {
                ...state,
                authStatus: requestStatuses.PENDING,
            };

        case TRANSACTIONS_AUTH_ERROR:
            return {
                ...state,
                authStatus: requestStatuses.ERROR,
            };

        case TRANSACTIONS_FETCH:
            return {
                ...state,
                fetchStatus: requestStatuses.PENDING,
            };

        case TRANSACTIONS_FETCH_SUCCESS:
            return {
                ...state,
                ...normalizeAccountTransactionsData(payload),
                fetchStatus: requestStatuses.SUCCESS,
            };

        case TRANSACTIONS_FETCH_ERROR:
            return {
                ...state,
                fetchStatus: requestStatuses.ERROR,
            };

        default:
            return state;
    }
}
